import axios from "axios";
import ClientContext from "common/utils/client-context/ClientContext";
import { log as pilog } from "common/utils/Logging";
import { handleAPIFailure } from "common/utils/api-log-helper/APILogHelper";
import { RESOURCE_PROCESSOR_MAP } from "./RemoteResourceUtil";
const fetchResources = (resourcesToFetch, callback) => {
  const log = pilog.getLogger("ResourceAPI fetchResources");
  const url = `${process.env.REACT_APP_BASE_PLATFORM_URL}community/resources`;
  const params = {
    headers: {
      "x-api-key": ClientContext._apiKey
    },
    timeout: parseInt(process.env.REACT_APP_HTTP_POST_TIMEOUT)
  };
  axios.post(url, resourcesToFetch, params).then(response => {
    log.debug(`Successfully retrieved ${response.data.length} resources`);
    const resourceResponseArray = [];
    response.data.map(platformResource => {
      try {
        const resource = resourcesToFetch.filter(r => r.resourceName === platformResource.resourceName)[0];
        //sometimes we may want to fetch "text" and but not parse to JSON e.g. if it's HTML
        const processorType = resource.processor ? resource.processor : resource.encoding;
        log.debug(`${processorType} for ${resource.resourceName}`);
        const processor = RESOURCE_PROCESSOR_MAP[processorType];
        resourceResponseArray.push(processor(platformResource));
      } catch (error) {
        log.warn(`Failed to process ${platformResource.resourceName} %o`, error);
      }
    });
    log.debug(`Successfully processed ${resourceResponseArray.length} resources`);
    callback(resourceResponseArray);
  }).catch(error => {
    handleAPIFailure(error);
    callback(null);
  });
};
export const fetchContentSkipPlatform = (resourceBundleUrl, onContent, onFailure) => {
  const log = pilog.getLogger("ResourceAPI fetchContentSkipPlatform");
  axios.get(resourceBundleUrl).then(response => {
    log.debug(`Successfully retrieved ${resourceBundleUrl}`);
    log.debug("response: ", response);
    //check to make sure there is data
    if (typeof onContent === "function") {
      onContent(response.data);
    }
  }).catch(() => {
    if (typeof onFailure === "function") {
      onFailure("File doesn't exist");
    }
  });
};
export const fetchPlatformResources = (options, successCallback, failureCallback) => {
  const log = pilog.getLogger("ResourceAPI fetchPlatformResources");
  if (options.locale === null) {
    delete options.locale;
  }
  const {
    resourceList,
    applicationName = ClientContext._appName,
    locale = ClientContext._locale,
    tenantName = ClientContext._tenantName,
    groupName = ClientContext._groupName,
    ignoreCache = false,
    tenantGroupOnly = false
  } = options;
  const resourceAPIRequests = [];
  resourceList === null || resourceList === void 0 ? void 0 : resourceList.map(resource => {
    var _resource$localeOverr;
    const resourceRequest = {
      tenantName,
      groupName,
      locale: (_resource$localeOverr = resource.localeOverride) !== null && _resource$localeOverr !== void 0 ? _resource$localeOverr : locale,
      resourceName: resource.name,
      applicationName: resource.applicationName ? resource.applicationName : applicationName,
      encoding: resource.encoding,
      processor: resource.processor,
      ignoreCache: resource.ignoreCache || ignoreCache,
      tenantGroupOnly
    };
    log.debug(resourceRequest);
    resourceAPIRequests.push(resourceRequest);
  });
  log.debug(`${resourceAPIRequests.length} Resource API requests`);
  if ((resourceAPIRequests === null || resourceAPIRequests === void 0 ? void 0 : resourceAPIRequests.length) > 0) {
    fetchResources(resourceAPIRequests, result => {
      if (result) {
        successCallback(result);
      } else {
        if (failureCallback) {
          failureCallback([], "Failed to find resources");
        } else {
          log.warn("Unable to load platform resources, defaults will be used");
          successCallback([]);
        }
      }
    });
  }
};